import { render, staticRenderFns } from "./LinkCustomer.vue?vue&type=template&id=58adba27&"
import script from "./LinkCustomer.vue?vue&type=script&lang=js&"
export * from "./LinkCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports